/// <amd-module name="VSS/Features/Frame/ResponsiveLayout" />
export * from "./ResponsiveLayout/ResponsiveLayout";
export {
    IAdjustment,
    IAdjustmentProps,
    IIndexedAdjustment,
    IResponsiveLayoutProps,
    ResponsiveOrientation
} from "./ResponsiveLayout/ResponsiveLayout.Props";
